import { Box, Button, styled } from '@mui/material';

export const BuilderContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0),
}));

export const AddSectionButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const AddButtonsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
  flexWrap: 'wrap',
}));

export const DRAG_OVERLAY_SX = {
  backgroundColor: 'background.paper',
  boxShadow: 4,
  borderRadius: 1,
  p: 0,
  opacity: 0.9,
};

export const DRAG_OVERLAY_ROW_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  px: 2,
  py: 1.5,
  backgroundColor: 'grey.100',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1,
  minWidth: 320,
};

export const DRAG_OVERLAY_NUMBER_SX = {
  fontWeight: 500,
  minWidth: 32,
  color: 'text.primary',
};
